'use memo'

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { getFinderSettings } from '@sportninja/common/services/player/finderSettingsService'

const STALE_TIME = 60 * 1000

export const useFinderSettings = (playerId?: string) =>
  useQuery({
    queryKey: queryKeys.finderSettings.byPlayer(playerId ?? ''),
    queryFn: () => getFinderSettings(playerId as string),
    enabled: Boolean(playerId),
    staleTime: STALE_TIME,
  })
